import { useRef } from "react";
import { Input } from "../../input";

interface TextFilterProps {
    value: string | null;
    onChange: (value: string) => void | Promise<void>;
    placeholder?: string | null;
    title?: string | null;
    description?: string | null;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};

const TextFilter = ({
    value,
    onChange,
    placeholder = "Search...",
    title,
    description,
    onKeyDown,
}: TextFilterProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        const input = e.target;
        const len = input.value.length;
        setTimeout(() => {
            input.setSelectionRange(len, len);
        }, 0);
    };

    return (
        <div onKeyDown={e => e.stopPropagation()}>
            <span className="block my-[10px] mx-[5px] uppercase text-xs text-[#6A7282]">
                {title || null}
            </span>
            <Input
                ref={inputRef}
                placeholder={placeholder || "Search..."}
                className="mb-2 block h-10"
                value={value || ""}
                onChange={e => onChange(e.target.value)}
                onFocus={handleFocus}
                onKeyDown={onKeyDown}
            />
            <span className="block m-[5px] text-[9px] text-[#959595]">
                {description || null}
            </span>
        </div>
    );
};

export default TextFilter;
